import { render, staticRenderFns } from "./CouponFloat.vue?vue&type=template&id=19d0fe38&"
import script from "./CouponFloat.vue?vue&type=script&lang=js&"
export * from "./CouponFloat.vue?vue&type=script&lang=js&"
import style0 from "./CouponFloat.vue?vue&type=style&index=0&id=19d0fe38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports